const ApiConfig = {
    baseUrl: "https://greeremit.com/prod/api",
};
export default ApiConfig;
